import React from 'react';
import { cnTooltip } from '../Tooltip';
import './Tooltip-Backdrop.css';
// prettier-ignore
export var TooltipBackdrop = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: cnTooltip('Backdrop') }, children));
};
